import { render } from "./AccordianItem.vue?vue&type=template&id=6b976827&scoped=true&ts=true"
import script from "./AccordianItem.vue?vue&type=script&lang=ts"
export * from "./AccordianItem.vue?vue&type=script&lang=ts"

import "./AccordianItem.vue?vue&type=style&index=0&id=6b976827&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b976827"]])

export default __exports__